import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { ReducerStatus, RootState } from '../types';
import { AuthState } from './types';
import { SemboUser } from '@/api/Members/members.interfaces';

const initialState: AuthState = {
    status: ReducerStatus.INITIAL,
    user: null,
};

const state: AuthState = {
    ...initialState,
};

const getters: GetterTree<AuthState, RootState> = {
    getUser(state): SemboUser | null {
        return state.user ?? null;
    },
    getIsLoaded(state): boolean {
        return (
            state.status !== ReducerStatus.INITIAL && state.status !== ReducerStatus.LOADING
        );
    },
};

const actions: ActionTree<AuthState, RootState> = {
    setUserMemberOptIn({ state, commit }) {
        commit('setState', {
            ...state,
            user: { ...state.user, member: { ...state.user?.member, isSembonusUser: true } },
        });
    },
    setUserLoading({ state, commit }) {
        commit('setState', {
            ...state,
            status: ReducerStatus.LOADING,
        });
    },
    setUserError({ state, commit }) {
        commit('setState', {
            ...state,
            user: null,
            status: ReducerStatus.ERROR,
        });
    },
    setUserSuccess({ state, commit }, payload) {
        commit('setState', {
            ...state,
            user: payload,
            status: ReducerStatus.LOADED,
        });
    },
};

const mutations: MutationTree<AuthState> = {
    setState(state, payload) {
        Object.assign(state, payload);
    },
};

export const auth: Module<AuthState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
